import { render } from "./Videos.vue?vue&type=template&id=58d757ec&scoped=true&ts=true"
import script from "./Videos.vue?vue&type=script&lang=ts"
export * from "./Videos.vue?vue&type=script&lang=ts"

import "./Videos.vue?vue&type=style&index=0&id=58d757ec&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studiostvapp/studiostvapp/PlatformStudiosApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d757ec"]])

export default __exports__